import request from './request';

export function getFaultCodeExplanationLogs(params) {
  return request({
    url: '/fault-code-explanation-log',
    method: 'get',
    params
  });
}

export function getFaultCodeExplanationLogById(id) {
  return request({
    url: `/fault-code-explanation-log/${id}`,
    method: 'get'
  });
}
